import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20digital%20landscape%20with%20warm%20golden%20amber%20and%20deep%20teal%20color%20gradient%2C%20futuristic%20gaming%20tech%20atmosphere%2C%20flowing%20particles%20and%20data%20streams%2C%20modern%20minimalist%20design%2C%20dark%20background%20with%20warm%20light%20accents%2C%20professional%20corporate%20style&width=1920&height=900&seq=hero-muguawan-2026&orientation=landscape"
        alt="木瓜玩游戏出海全球营销平台"
        title="木瓜玩 - 海外游戏发行与用户增长平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-5xl mx-auto text-center">
        <h1 className="font-heading font-bold text-2xl md:text-5xl lg:text-6xl text-white leading-tight mb-4 md:mb-6">
          游戏出海<span className="text-primary-400">一站式增长</span>引擎
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed mb-6 md:mb-8">
          专注海外游戏发行、买量投放与用户增长，提供精准广告投放、数据分析、创意素材制作等全链路服务，助力游戏企业拓展全球市场
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            免费获取增长方案
          </Link>
          <Link
            to="/articles"
            className="px-7 py-3 bg-white/10 hover:bg-white/20 text-white text-sm md:text-base font-medium rounded-md backdrop-blur-sm border border-white/20 transition-all duration-200 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            查看行业洞察
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-5 md:gap-8 mt-8 md:mt-12">
          {['Meta Ads', 'Google Ads', 'TikTok', 'Unity Ads', 'Apple Search'].map((platform) => (
            <span
              key={platform}
              className="text-xs md:text-sm text-white/60 font-medium tracking-wide whitespace-nowrap"
            >
              {platform}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}